import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { ThinChevronIcon } from 'components/Utils/Icons'
import Badge from 'components/base/Badge'

class BreadCrumbs extends React.Component {
  static propTypes = {
    step: PropTypes.oneOf([1, 2, 3]),
    onSelected: PropTypes.func.isRequired,
  }

  static defaultProps = {
    onSelected: () => {},
  }

  steps = ['destination', 'source', 'import']

  render() {
    return (
      <section className="flexbox flexbox-align-center margin-bottom-large">
        {this.steps.map((stepName, index) => {
          const isSelectedStep = index === this.props.step - 1
          const isBeforeSelectedStep = index < this.props.step - 1

          return (
            <React.Fragment key={index}>
              <Badge
                active={isSelectedStep}
                className={classnames('inline-block', 'font-family-system', {
                  pointer: isBeforeSelectedStep,
                })}
                style={{ letterSpacing: 0.5 }}
                onClick={() => {
                  if (isBeforeSelectedStep) {
                    this.props.onSelected(stepName)
                  }
                }}
              >
                {stepName}
              </Badge>
              {index !== 2 && (
                <ThinChevronIcon
                  size={12}
                  className={classnames('margin-horizontal-small shade-30')}
                />
              )}
            </React.Fragment>
          )
        })}
      </section>
    )
  }
}

export default BreadCrumbs
